import React, { useState, useEffect } from "react";
import GoujianImages from "./GoujianImages";
import GoujianTiaowens from "./GoujianTiaowens";
import GoujianTypes from "./GoujianTypes";
import GoujianBasic from "./GoujianBasic";
import SERVER_ADDRESS from "../../../../config";

function useGoujian(initValue, fetchUrl, goujianId) {
  const [goujian, setGoujian] = useState(initValue);
  useEffect(() => {
    async function getGoujian() {
      const goujian = await fetch(fetchUrl, {
        mode: "cors",
        credentials: "include"
      }).then(res => {
        return res.json();
      });

      setGoujian(goujian);
    }
    getGoujian();
  }, [goujianId]);

  //freshData
  const freshData = (data, method = "update") => {
    setGoujian(data);
  };
  return { goujian, freshData };
}

function GoujianDetail(props) {
  const { goujianId } = props;

  let goujianQuery = `${SERVER_ADDRESS}/api/goujians/${goujianId}/`;
  const { goujian, freshData } = useGoujian({}, goujianQuery, goujianId);

  return (
    <>
      <GoujianBasic
        goujianId={goujianId}
        goujian={goujian}
        freshData={freshData}
      />

      <GoujianImages goujianId={goujianId} goujian={goujian} />
      <GoujianTiaowens goujianId={goujianId} goujian={goujian} />
      <GoujianTypes goujianId={goujianId} goujian={goujian} />
    </>
  );
}

export default GoujianDetail;
